/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFilter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M1.32 2.684A.75.75 0 012 2.25h20a.75.75 0 01.573 1.234l-7.823 9.25V21a.75.75 0 01-1.085.67l-4-2A.75.75 0 019.25 19v-6.265l-7.823-9.25a.75.75 0 01-.107-.8zM3.616 3.75l6.957 8.226a.75.75 0 01.177.484v6.076l2.5 1.25V12.46a.75.75 0 01.177-.484l6.957-8.226H3.616z'
      />
    </svg>
  );
}

export default SvgFilter;
